import script from "./CRM60_004INS.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM60_004INS.vue?vue&type=script&setup=true&lang=js"

import "./CRM60_004INS.vue?vue&type=style&index=0&id=798f62b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798f62b6"]])

export default __exports__